var SupportModule = (function () {
    function SupportModule() {
    }
    return SupportModule;
}());
export { SupportModule };



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/support/support.module.ts.pre-build-optimizer.js